import { fmtWhen, toLocalInputValue } from '../lib/time';
import { useAppStore } from '../state/store';
import { IconClock } from './Icons';
import { Segmented } from './Segmented';

type TimeMode = 'now' | 'plan';

export function TimeControl() {
  const departNow = useAppStore((s) => s.departNow);
  const departMs = useAppStore((s) => s.departMs);
  const setDepartNow = useAppStore((s) => s.setDepartNow);
  const setDepartMs = useAppStore((s) => s.setDepartMs);

  return (
    <div className="control">
      <div className="control__head">
        <span className="control__icon">
          <IconClock size={15} />
        </span>
        <span className="control__title">Partenza</span>
        <span className="control__value t-num">{departNow ? 'Adesso' : fmtWhen(departMs)}</span>
      </div>
      <Segmented<TimeMode>
        value={departNow ? 'now' : 'plan'}
        options={[
          { value: 'now', label: 'Adesso' },
          { value: 'plan', label: 'Programma' },
        ]}
        onChange={(v) => setDepartNow(v === 'now')}
        ariaLabel="Orario di partenza"
      />
      {!departNow && (
        <div className="control__extra row">
          <input
            type="datetime-local"
            className="datetime grow"
            aria-label="Data e ora di partenza"
            value={toLocalInputValue(departMs)}
            onChange={(e) => {
              const t = Date.parse(e.target.value);
              if (Number.isFinite(t)) setDepartMs(t);
            }}
          />
          <button
            type="button"
            className="btn btn--xs btn--plain"
            title="Sposta di mezz'ora"
            onClick={() => setDepartMs(departMs + 30 * 60_000)}
          >
            +30 min
          </button>
          <button
            type="button"
            className="btn btn--xs btn--plain"
            title="Sposta di un'ora"
            onClick={() => setDepartMs(departMs + 60 * 60_000)}
          >
            +1 h
          </button>
        </div>
      )}
    </div>
  );
}
